import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { PerformanceCycleProvider } from "@/contexts/PerformanceCycleContext";
import { Layout, ProtectedRoute } from "@/components/Layout";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import GoalsPage from "@/pages/GoalsPage";
import TeamGoalsPage from "@/pages/TeamGoalsPage";
import UsersPage from "@/pages/UsersPage";
import CompetenciesPage from "@/pages/CompetenciesPage";
import SettingsPage from "@/pages/SettingsPage";
import ReportsPage from "@/pages/ReportsPage";
import AuditLogPage from "@/pages/AuditLogPage";
import MidYearReviewPage from "@/pages/MidYearReviewPage";
import YearEndReviewPage from "@/pages/YearEndReviewPage";
import CalibrationPage from "@/pages/CalibrationPage";
import OrgSettingsPage from "@/pages/OrgSettingsPage";
import PerformanceCyclePage from "@/pages/PerformanceCyclePage";
import OrganizationStatusPage from "@/pages/OrganizationStatusPage";
import GoalLibraryPage from "@/pages/GoalLibraryPage";

function App() {
  return (
    <AuthProvider>
      <PerformanceCycleProvider>
        <BrowserRouter>
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<LoginPage />} />
            
            {/* Protected routes with layout */}
            <Route element={<Layout />}>
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/goals" element={<GoalsPage />} />
              <Route 
                path="/team-goals" 
                element={
                <ProtectedRoute roles={['admin', 'hr', 'manager']}>
                  <TeamGoalsPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/users" 
              element={
                <ProtectedRoute roles={['admin', 'hr']}>
                  <UsersPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/competencies" 
              element={
                <ProtectedRoute roles={['admin']}>
                  <CompetenciesPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/settings" 
              element={
                <ProtectedRoute roles={['admin']}>
                  <SettingsPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/reports" 
              element={
                <ProtectedRoute roles={['admin', 'hr']}>
                  <ReportsPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/audit-logs" 
              element={
                <ProtectedRoute roles={['admin']}>
                  <AuditLogPage />
                </ProtectedRoute>
              } 
            />
            <Route
              path="/org-settings"
              element={
                <ProtectedRoute roles={['admin']}>
                  <OrgSettingsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/goal-library"
              element={
                <ProtectedRoute roles={['admin']}>
                  <GoalLibraryPage />
                </ProtectedRoute>
              }
            />
            <Route 
              path="/performance-cycle" 
              element={
                <ProtectedRoute roles={['admin', 'hr']}>
                  <PerformanceCyclePage />
                </ProtectedRoute>
              } 
            />
            <Route path="/reviews/mid-year" element={<MidYearReviewPage />} />
            <Route path="/reviews/year-end" element={<YearEndReviewPage />} />
            <Route 
              path="/reviews/calibration" 
              element={
                <ProtectedRoute roles={['admin', 'hr']}>
                  <CalibrationPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/organization-status" 
              element={
                <ProtectedRoute roles={['admin', 'hr']}>
                  <OrganizationStatusPage />
                </ProtectedRoute>
              } 
            />
          </Route>
          
          {/* Default redirect */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
      </PerformanceCycleProvider>
    </AuthProvider>
  );
}

export default App;
